import React from 'react';
import { Box } from '@wds/box';
import { PackageProps } from '~shared/types/pricing/package';

import PackageHeader from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/PackageHeader';
import usePackageStyles from './useStyles';
import PackageDefs from '~pricing/lib/packages/packageDefs';
import { PackageDefs as Grow2792PackageDefs } from '~pricing/experiments/grow_2792_pnp_refresh_v1/constants';
import FeatureSet from '../FeatureSet';
import PaidFeatures from '../PaidFeatures';

const expPackageDefs = { ...PackageDefs, ...Grow2792PackageDefs };

export default function Package({
  skuCost,
  packageName,
  paidFeatures,
}: Readonly<PackageProps>): React.ReactElement | null {
  const { PricingPackageContainer, PricingPackage, Highlighted } = usePackageStyles({
    packageName,
  });

  return (
    <Box
      element="article"
      className={`${PricingPackageContainer} package-${packageName}`}
      key={packageName}
      data-testid="Package"
    >
      <Box className={`${PricingPackage} ${expPackageDefs[packageName]?.highlighted ? Highlighted : ''}`}>
        <PackageHeader packageName={packageName} skuCosts={skuCost} isSummaryPage />
        {paidFeatures && <PaidFeatures paidFeatures={paidFeatures} packageName={packageName} />}
        <FeatureSet packageName={packageName} hasPaidFeatures={!!paidFeatures} />
      </Box>
    </Box>
  );
}
